module.exports = __webpack_public_path__ + "media/images/shinagawa-alt-244aaf63ef2e12251a5982b9dd390345.png";